import { render } from "./ModalDetalleEjecucionPresupuestaria.vue?vue&type=template&id=fa22b3f4&scoped=true"
import script from "./ModalDetalleEjecucionPresupuestaria.vue?vue&type=script&lang=js"
export * from "./ModalDetalleEjecucionPresupuestaria.vue?vue&type=script&lang=js"

import "./ModalDetalleEjecucionPresupuestaria.vue?vue&type=style&index=0&id=fa22b3f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa22b3f4"]])

export default __exports__